export default __webpack_public_path__ + "static/media/sparkofgenius_jonas_bienz_website_still.b35d1dc6.jpg";